<template>
    <v-container class="pa-0 py-2" style="width: 145px">
        <div class="justify-center align-center">
            <div>
                <div v-if="item.isPartial">
                    <v-btn
                        small
                        color="secondary"
                        :href="createPartialProductLink(item)"
                        ><TranslatableStringComponent
                            :tstring="{ string: 'configure' }"
                    /></v-btn>
                </div>
                <div v-else-if="item.quantityInCart === 0">
                    <v-btn
                        :small="$i18n.locale === 'en'"
                        :x-small="$i18n.locale === 'es'"
                        color="primary"
                        @click="addToCart(item)"
                    >
                        <TranslatableStringComponent
                            :tstring="{ string: 'addToCart' }"
                        />
                    </v-btn>
                </div>
                <div v-else class="d-flex">
                    <v-btn
                        v-if="item.quantityInCart > 1"
                        height="32"
                        x-small
                        icon
                        @click="dialog = !dialog"
                    >
                        <fa
                            :icon="['fal', 'trash-alt']"
                            class="fa-md"
                        /> </v-btn
                    ><InputFieldStepper :item="item" :isShopPage="true" />
                </div>
            </div>
            <div
                v-show="
                    !item.isPartial &&
                    item.quantityInCart > 0 &&
                    item.subTotalSalePrice
                "
            >
                <div>
                    <span
                        ><del> {{ dollars(item.subTotalListPrice) }}</del></span
                    >
                </div>
                <div
                    v-show="
                        !item.isPartial &&
                        item.quantityInCart > 0 &&
                        item.subTotalSalePrice
                    "
                >
                    <span class="dollars">
                        {{ dollars(item.subTotalSalePrice) }}
                    </span>
                </div>
            </div>
            <!-- <div
                v-show="
                    !item.isPartial &&
                    item.quantityInCart > 0 &&
                    item.subTotalSalePrice
                "
            >
                <v-btn
                    v-if="
                        !localShopPageProductAvailability ||
                        (localShopPageProductAvailability &&
                            !localShopPageProductAvailability.isFresh)
                    "
                    x-small
                    color="secondary"
                    block
                    :loading="itemAvailabilityLoading"
                    outlined
                    class="mb-1"
                    @click="checkProductAvailability"
                >
                    <TranslatableStringComponent
                        :tstring="{ string: 'checkAvailability' }"
                    />
                </v-btn>
                <AlertForRealTimeInventory
                    v-else
                    :text="false"
                    :item-availability="localShopPageProductAvailability"
                    :is-shop-page="true"
                />
            </div> -->
        </div>
        <v-dialog v-model="dialog" width="500" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <TranslatableStringComponent
                        :tstring="{ string: 'remove' }"
                    />
                    {{ item.pn }}?
                </v-card-title>
                <v-card-text>
                    <p>
                        <TranslatableStringComponent
                            :tstring="{
                                string: 'confirmRemoveFromCart',
                                variables: [
                                    {
                                        var: item.quantityInCart,
                                        tag: 'strong',
                                    },
                                    {
                                        var: item.pn,
                                        tag: 'strong',
                                    },
                                ],
                            }"
                        />
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog = false">
                        <TranslatableStringComponent
                            :tstring="{ string: 'keep' }"
                        />
                    </v-btn>
                    <v-btn color="error" text @click="removeItem(item.pn)">
                        <TranslatableStringComponent
                            :tstring="{ string: 'remove' }"
                        />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import InputFieldStepper from '~/components/InputFieldStepper.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import AlertForRealTimeInventory from '~/components/AlertForRealTimeInventory.vue'
import { gtmEvent } from '~/plugins/global'
export default {
    name: 'ColumnAction',
    components: {
        InputFieldStepper,
        TranslatableStringComponent,
        AlertForRealTimeInventory,
    },
    data() {
        return {
            dialog: false,
            itemAvailabilityLoading: false,
        }
    },
    props: {
        item: {
            type: Object,
            default: null,
        },
    },
    // watch: {
    //     item(newVal, oldVal) {
    //         if (
    //             newVal.quantityInCart !==
    //             (this.localShopPageProductAvailability?.qtyRequested ||
    //                 oldVal.quantityInCart)
    //         ) {
    //             this.$store.dispatch(
    //                 'realTimeInventoryData/updateDataStateForAvailability',
    //                 { pn: this.item.pn }
    //             )
    //         }
    //     },
    // },
    computed: {
        // ...mapGetters({
        //     cartProductsAvailability:
        //         'realTimeInventoryData/fetchCartProductsAvailability',
        //     availabilityLoading:
        //         'realTimeInventoryData/fetchAvailabilityLoadingState',
        // }),
        localShopPageProductAvailability() {
            return this.cartProductsAvailability?.find(
                (item) => item.partNumberErp === this.item.pn
            )
        },
    },
    methods: {
        addToCart(item) {
            this.$store.dispatch('cart/updateCart', item)
            gtmEvent({
                gtm: this.$gtm,
                event: 'addToCart',
                eventType: 'click',
                atts: {
                    c3source: 'shop',
                    ecommerce: {
                        currencyCode: 'USD',
                        add: {
                            products: [
                                {
                                    id: item.pn,
                                    name: item.name_en,
                                    price: item.sale_price.toFixed(2),
                                    category:
                                        item.categories && item.categories[0]
                                            ? item.categories[0]
                                            : 'not recorded',
                                    product_id: item.product_id,
                                },
                            ],
                        },
                    },
                },
            })
        },
        createPartialProductLink(item) {
            if (item.parent) {
                const path = this.localePath({
                    name: 'products-slug',
                    params: {
                        slug: item.parent[this.$i18n.locale].current,
                        pn: item.partialSlug,
                    },
                })
                return `${path}/${item.partialSlug}/`
            } else {
                return ''
            }
        },
        removeItem() {
            this.$store.dispatch('cart/removeItem', this.item)
            this.dialog = false
        },
        // async checkProductAvailability() {
        //     this.itemAvailabilityLoading = true
        //     await this.$store.dispatch(
        //         'realTimeInventoryData/checkProductAvailabilityInRealTimeInventory',
        //         {
        //             products: [this.item],
        //         }
        //     )
        //     this.itemAvailabilityLoading = false
        // },
    },
}
</script>

<style></style>
